"use client";

import { ReturnTypeWithPagination, Vehicle } from "@alba-cars/common-modules";
import { type ReactNode } from "react";

import { FilterProvider } from "./context/FilterContext";
import { CarsQueryProvider } from "./context/QueryContext";

interface BuyUsedCarsContentProps {
  searchParams: Record<string, any>;
  cars?: ReturnTypeWithPagination<Vehicle[]>;
  children: ReactNode;
}

export default function BuyUsedCarsContent({ searchParams, cars, children }: BuyUsedCarsContentProps) {
  return (
    <FilterProvider searchParams={searchParams}>
      <CarsQueryProvider cars={cars}>{children}</CarsQueryProvider>
    </FilterProvider>
  );
}
